import { http } from './http';
import { checkOrCreateBookByDate } from './book';

function ensurePk(v) {
    // Возвращает примитив (string/number) если может извлечь pk, иначе undefined
    if (v === null || v === undefined) return undefined;
    if (Array.isArray(v)) {
        if (!v.length) return undefined;
        return ensurePk(v[0]);
    }
    if (typeof v === 'object') {
        // Часто приходит как { id: 123 } или { book: { id: 123 } }
        if ('id' in v && (typeof v.id === 'number' || typeof v.id === 'string')) return v.id;
        if ('book' in v) return ensurePk(v.book);
        // Если объект но без явного id — не отправляем его как есть
        return undefined;
    }
    // Примитив
    if (typeof v === 'number' || typeof v === 'string') return v;
    return undefined;
}

function normalizeResultPayload(p, { dateISO } = {}) {
    if (!p || typeof p !== 'object') return p;
    const out = {};

    // book — оставляем как есть, позже добьём если нет (строго pk)
    if (p.book !== undefined) {
        const bk = ensurePk(p.book);
        if (bk !== undefined) out.book = bk; // только pk
    }

    // check_type_id: поддержка различных форматов + извлечение из объекта/массива
    let ctRaw = p.check_type_id ?? p.checkTypeId ?? p.check_type ?? p.checkType;
    if (Array.isArray(ctRaw)) ctRaw = ctRaw[0];
    if (ctRaw && typeof ctRaw === 'object' && ctRaw !== null && 'id' in ctRaw) ctRaw = ctRaw.id;
    if (ctRaw !== undefined && ctRaw !== null) {
        const numCt = Number(ctRaw);
        const val = Number.isFinite(numCt) ? numCt : ctRaw;
        out.check_type_id = val;
    }

    // square
    if (p.square !== undefined && p.square !== null) out.square = String(p.square).trim();

    // text
    if (p.text !== undefined && p.text !== null) out.text = p.text;

    // border_patrol_type / patrol_type
    let bpt = p.border_patrol_type ?? p.patrol_type ?? p.patrolType ?? p.borderPatrolType;
    if (Array.isArray(bpt)) bpt = bpt[0];
    if (bpt && typeof bpt === 'object' && bpt !== null && 'id' in bpt) bpt = bpt.id; // на случай если придёт объект
    if (bpt !== undefined && bpt !== null) out.border_patrol_type = bpt;

    // check_time:
    let rawTime = p.check_time ?? p.checkTime;
    if (!rawTime) rawTime = p.time; // может быть HH:MM
    if (rawTime) {
        if (/^\d{2}:\d{2}$/.test(rawTime) && dateISO) {
            out.check_time = `${dateISO}T${rawTime}:00`;
        } else if (/^\d{1}:\d{2}$/.test(rawTime) && dateISO) {
            const parts = rawTime.split(':');
            const hh = parts[0].padStart(2, '0');
            out.check_time = `${dateISO}T${hh}:${parts[1]}:00`;
        } else {
            out.check_time = rawTime;
        }
    }

    return out;
}

export async function listResults(params = {}) {
    const { data } = await http.get('book/results/', { params });
    return data;
}

export async function getResult(id) {
    const { data } = await http.get(`book/results/${id}/`);
    return data;
}

export async function createResult(payload, { dateISO } = {}) {
    const normalized = normalizeResultPayload(payload, { dateISO });
    // если book не указан – получим/создадим по дате и подставим
    if (normalized.book === undefined && dateISO) {
        try {
            const bookCtx = await checkOrCreateBookByDate(dateISO);
            const pk = ensurePk(bookCtx);
            if (pk !== undefined) normalized.book = pk;
        } catch (e) {
            console.warn('Не удалось получить bookId по dateISO для results', e);
        }
    }
    const { data } = await http.post('book/results/', normalized);
    return data;
}

export async function updateResult(id, payload, { dateISO } = {}) {
    const normalized = normalizeResultPayload(payload, { dateISO });
    if (normalized.book === undefined && dateISO) {
        try {
            const bookCtx = await checkOrCreateBookByDate(dateISO);
            const pk = ensurePk(bookCtx);
            if (pk !== undefined) normalized.book = pk;
        } catch (e) {
            console.warn('Не удалось получить bookId по dateISO для results (update)', e);
        }
    }
    const { data } = await http.patch(`book/results/${id}/`, normalized);
    return data;
}


export async function deleteResult(id) {
    const { data } = await http.delete(`book/results/${id}/`);
    return data;
}